import {graphConfigErrors,validAxis,type GraphConfig,type Axis} from './graph-configuration';

/** Optional second ordinate applies to correction figures, never to student axes. */
export type CorrectionGraphConfig=Partial<GraphConfig>&{secondaryY?:Axis;secondarySeriesIds?:string[]};
export function correctionGraphErrors(input:CorrectionGraphConfig):string[]{
 const errors=graphConfigErrors(input);
 if(input.secondaryY!==undefined&&!validAxis(input.secondaryY))errors.push('Axe droit de correction invalide.');
 if(input.secondarySeriesIds!==undefined&&(!input.secondaryY||!Array.isArray(input.secondarySeriesIds)||!input.secondarySeriesIds.length||new Set(input.secondarySeriesIds).size!==input.secondarySeriesIds.length||input.secondarySeriesIds.some(id=>!input.series?.some(s=>s.id===id))))errors.push('Séries de l’axe droit invalides.');
 if(input.secondaryY&&!input.secondarySeriesIds?.length)errors.push('Choisir les séries de l’axe droit.');
 return errors;
}
